import { Model } from '@/app/shared/models/model';

export class PaymentInfoPixModel extends Model {
  public Cpf?: string;
  public Cnpj?: string;
  public CellPhone?: string;
  public Email?: string;
  public RandomKey?: string;
  public BranchNumber?: string;
  public BranchDigit?: string;
  public AccountNumber?: string;
  public AccountDigit?: string;
  public TypePix?: number;
}
